












import { Component, Vue } from "vue-property-decorator";
import Menu from "./views/Menu.vue";
import Foot from "./views/Footer.vue";
import BackTop from "./components/BackToTop.vue";
import Nav from "./views/Nav.vue";

@Component({
  components: {
    Menu,
    Foot,
    BackTop,
    Nav
  }
})
export default class App extends Vue {
  private mounted() {
    if (this.$store.state.language === "en-US") {
      document.title = "Dr. Tie Qiu's Homepage";
    }
    if(this.$route.path == '/en' && this.$store.state.language === "zh-CN") {
      this.$store.commit("changeLanguage");
      document.title = "Dr. Tie Qiu's Homepage";
      console.log(document.title);
      return;
    }
    let lang = this.$route.query.lang;
    if (!lang) {
      var jsQuery = window.location.search.substring(1);
      var vars = jsQuery.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == "lang") {
          lang = pair[1];
          break;
        }
      }
    }
    if (lang === "en-US" && this.$store.state.language === "zh-CN") {
      this.$store.commit("changeLanguage");
    } else {
      // donothing
    }
  }
}
